import { AxiosPostUrl } from "../../functions/axiosfunctions";

export function getAdminAllLogs(data: Object, cb = function (reponse: any) {}) {
  AxiosPostUrl(
    "/administration/admin/logs",
    data,
    (reponse) => {
      if (reponse) {
        cb(reponse);
      } else {
        cb({
          success: false,
          data: {},
          msg: "Erreur survenue !",
        });
      }
    },
    function (reponse) {
      cb({
        success: false,
        data: {},
        msg: "Erreur survenue !",
      });
    }
  );
}
